import * as Help from "../Actions/help";
import Workflow from "../lib/Workflow";

/**
 * 与时序图联动重构
 * 1、动作按距离开始时间排序
 * 2、相同时间动作分组处理，精度控制在0.1秒
 * 3、动作本身长度固定为1秒--暂不支持编辑，后续加入编辑
 * 4、依次执行
 * 00--
 *   0--
 * 
 * todo:数据结构得变
 */

let MilitarySimulation = {


    start(tableData, callback) {
        Help.clear();


        let startTime = 0;
        let endTime = 0;

        let timeSegments = tableData.map((item, index) => {
            var delay = item.delay * 1000;
            item.continue = 1; //秒
            var continueTime = item.continue * 1000;

            startTime = index == 0 ? delay : endTime + delay;
            endTime = index == 0 ? startTime + continueTime : endTime + continueTime + delay;

            let s = {
                item: item,
                beginTime: startTime,
                endTime: endTime,
            };

            return s;
        });

        let beginTime = new Date();  // 当前时间
        function preRender_eventHandler() {

            var endTime = new Date();

            // 获取时间差（以毫秒为单位）
            var diff = endTime.getTime() - beginTime.getTime();

            var [firstElement] = timeSegments;
            if (diff >= firstElement.beginTime) {
                let item = firstElement.item;
                Help["action_" + item.type](item); //执行
                timeSegments.shift(); //剔除
            }

            callback && callback(diff);
            if (timeSegments.length < 1) {
                viewer.scene.preRender.removeEventListener(preRender_eventHandler);
            }
        }

        viewer.scene.preRender.addEventListener(preRender_eventHandler);
    },

    startTimeLine(timeSegments, startTime, stopTime, callback) {
        Help.clear();
        let beginTime = new Date();  // 当前时间
        function preRender_eventHandler() {

            var endTime = new Date();

            // 获取时间差（以毫秒为单位）
            var diff = startTime + endTime.getTime() - beginTime.getTime();

            if (timeSegments.length > 0) {
                var [firstElement] = timeSegments;
                if (diff >= firstElement.beginTime) {
                    let item = firstElement.item;
                    Help["action_" + item.type](item); //执行
                    timeSegments.shift(); //剔除
                }
            }
            callback && callback(diff);
            if (diff >= stopTime) {
                viewer.scene.preRender.removeEventListener(preRender_eventHandler);
            }
        }

        viewer.scene.preRender.addEventListener(preRender_eventHandler);
    },

    //开始推演
    startBack(tableData, callback) {
        Help.clear();
        var list = tableData || [];
        var funs = [];
        for (let i = 0; i < list.length; i++) {
            funs.push({
                fun: this.createPromise,
                delay: list[i].delay * 1000,
                params: list[i],
            });
        }
        var wf = new Workflow(funs);
        wf.runWorkflow();

        callback && callback(wf)
    },

    //停止推演
    stop() {

    },

    //暂停推演
    pause() {

    },

    //继续推演
    resume() { },


    createPromise(item) {
        item.complete = false; //标记是否完成
        var type = item.type;  //动作类型
        return new Promise((resolve) => {
            Help["action_" + type](item); //执行
            console.log(item);
            //item.complete = true;
            let timer = setInterval(() => {
                if (item.complete) {
                    clearInterval(timer);
                    resolve();
                }
            }, 20);
        });
    },
};


export default MilitarySimulation;